import Vue from 'vue'

/**
 * Composable for handle the kompack product variants list.
 * This composable is used to fetch the kompack product variants list and perform search by variant name.
 * @param {Object} vm - Vue component instance
 * @param {number} delay - Delay dalam milliseconds (default: 500)
 * @returns {Object} Object berisi state dan methods
 */
export default function useVariantList(vm, delay = 500) {
  const internalState = vm.$data
  if (!internalState.searchDebounceId) {
    internalState.searchDebounceId = null
  }
  if (!internalState.lastSearchedKeyword) {
    internalState.lastSearchedKeyword = ''
  }

  let originalData = []

  const state = Vue.observable({
    data: [],
    isLoading: false,
    error: null,
  })

  const fetchVariantsData = async ({
    product_id,
  }) => {
    state.isLoading = true
    state.error = null

    try {
      const response = await vm.$http_new.get('/komship/api/v1/product-variants', {
        params: {
          product_id,
        },
      })
      const { data } = response.data

      state.data = data
      originalData = data
    } catch (error) {
      state.error = error.message
    } finally {
      state.isLoading = false
    }
  }

  const performSearch = keyword => {
    const normalizedKeyword = (keyword || '').trim()

    // Skip if keyword unchanged
    if (normalizedKeyword === internalState.lastSearchedKeyword) {
      return
    }

    internalState.lastSearchedKeyword = normalizedKeyword

    state.data = originalData.filter(item => item.variant_name.toLowerCase().includes(normalizedKeyword.toLowerCase()))
  }

  const handleSearchInput = keyword => {
    if (internalState.searchDebounceId) {
      clearTimeout(internalState.searchDebounceId)
    }

    if (!keyword) {
      state.data = originalData
      return
    }

    internalState.searchDebounceId = setTimeout(() => {
      performSearch(keyword)
    }, delay)
  }

  const cleanupSearch = () => {
    if (internalState.searchDebounceId) {
      clearTimeout(internalState.searchDebounceId)
      internalState.searchDebounceId = null
    }
    internalState.lastSearchedKeyword = ''
  }

  const reset = () => {
    cleanupSearch()
  }

  return {
    state,
    fetchVariantsData,
    handleSearchInput,
    performSearch,
    cleanupSearch,
    reset,
  }
}
